<template>
  <div>
    <div class="card" v-if="tournament">
      <h2 style="margin:0;">{{ tournament.title }}</h2>
      <p style="margin:.25rem 0 0 0;"><span class="badge">{{ tournament.game }}</span> • {{ formatDate(tournament.eventDate) }}</p>
    </div>

    <div class="card">
      <h3>Clasificación</h3>
      <div class="table-wrap">
        <table class="table">
          <thead><tr><th>Rank</th><th>Jugador</th><th>Puntos</th><th>OMW</th><th>OOMW</th></tr></thead>
          <tbody>
            <tr v-for="s in standings" :key="s.rank">
              <td>{{ s.rank }}</td>
              <td>{{ s.name }}</td>
              <td>{{ s.winPoints }}</td>
              <td>{{ s.omw }}</td>
              <td>{{ s.oomw }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card">
      <h3>Reclamar mi alias</h3>
      <p>Selecciona tu nombre tal y como apareciste en el torneo para vincular tus puntos a tu usuario.</p>

      <div class="row">
        <div class="col">
          <input class="input" placeholder="Buscar..." v-model="q">
        </div>
      </div>

      <table class="table" style="margin-top:10px;">
        <thead><tr><th>Jugador</th><th>Membership</th><th>Estado</th><th></th></tr></thead>
        <tbody>
          <tr v-for="p in filtered" :key="p.participantId">
            <td>{{ p.displayName }}</td>
            <td>{{ p.membershipNumber || '-' }}</td>
            <td>
              <span v-if="p.claimed" class="badge" :style="{background: p.claimedByMe ? '#d3f9d8' : '#ffe3e3'}">
                {{ p.claimedByMe ? 'Tuyo' : 'Ocupado' }}
              </span>
              <span v-else class="badge">Libre</span>
            </td>
            <td style="text-align:right;">
              <button
                  class="btn"
                  :disabled="(p.claimed && !p.claimedByMe) || (hasMyClaim && !p.claimedByMe)"
                  @click="toggleClaim(p)"
              >
                {{ p.claimedByMe ? 'Soltar' : (hasMyClaim ? 'No disponible' : 'Reclamar') }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-if="!isAuth" style="color:#c92a2a;">Debes iniciar sesión para reclamar tu alias.</p>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
import store from '../store';
import {mapGetters} from "vuex";

export default {
  data: () => ({
    tournament: null,
    standings: [],
    participants: [],
    q: '',
    isAuth: store.getters.isAuth
  }),
  async created() {
    const id = this.$route.params.id;
    const { data } = await api.get(`/api/tournaments/${id}/standings`);
    this.tournament = { tournamentId: id, title: data.title, game: data.game, eventDate: data.eventDate };
    this.standings = data.standings;

    if (this.isAuth) {
      await this.loadParticipants();
    }
  },
  computed: {
    ...mapGetters(['isAuth']),
    hasMyClaim() {
      return this.participants.some(p => p.claimedByMe);
    },
    filtered() {
      const q = this.q.trim().toLowerCase();
      if (!q) return this.participants;
      return this.participants.filter(p => (p.displayName || '').toLowerCase().includes(q));
    }
  },
  methods: {
    formatDate(d) { return new Date(d).toLocaleDateString(); },
    async loadParticipants() {
      const id = this.$route.params.id;
      const { data } = await api.get(`/api/tournaments/${id}/participants`);
      this.participants = data;
    },
    async toggleClaim(p) {
      const id = this.$route.params.id;
      try {
        if (p.claimedByMe) {
          await api.delete(`/api/tournaments/${id}/claim`, { data: { participantId: p.participantId } });
        } else {
          await api.post(`/api/tournaments/${id}/claim`, { participantId: p.participantId });
        }
        await this.loadParticipants();
      } catch (e) {
        alert((e.response && e.response.data && e.response.data.error) || 'Error');
      }
    }
  }
}
</script>
